import { useMemo, useCallback, Fragment } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAMS } from '@constants/router';
import type { l10nType } from '@type/index';

interface IPagingMoreProps {
  l10n: l10nType;
  endPage?: number; // search api는 endPage를 줌
  hasMore?: boolean; // community api는 hasMore를 줌
  clickCallback?: () => void;
}

const PagingMore = ({ endPage, hasMore, l10n, clickCallback }: IPagingMoreProps) => {
  const MIN_PAGE = 1;
  const MAX_PAGE = endPage;
  const [searchParams, setSearchParams] = useSearchParams();
  const page = useMemo(() => (searchParams.get(SEARCH_PARAMS.PAGE) ? parseInt(searchParams.get(SEARCH_PARAMS.PAGE)!, 10) : MIN_PAGE), [searchParams]);
  const isBtnMoreShow = useMemo(
    () => page >= MIN_PAGE && ((MAX_PAGE && page < MAX_PAGE) || (typeof hasMore === 'boolean' && hasMore)),
    [page, hasMore]
  );

  const btnMoreClickCallback = useCallback(() => {
    searchParams.set(SEARCH_PARAMS.PAGE, `${page + 1}`);
    setSearchParams(searchParams);
    typeof clickCallback === 'function' && clickCallback();
  }, [searchParams]);

  return isBtnMoreShow ? (
    <div className="search-paging-more">
      <button type="button" className="search-paging-more-btn" onClick={btnMoreClickCallback}>
        {l10n?.template?.more}
      </button>
    </div>
  ) : (
    <Fragment />
  );
};

export default PagingMore;
